import React from 'react';
import { Section } from './ui/Section';
export function BonusIntroSection() {
  return <Section className="px-6 md:px-12 max-w-3xl mx-auto border-t border-[#d4a853]/10" data-id="element-96">
      <div className="text-center space-y-8" data-id="element-97">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#f0c674]" data-id="element-98">
          "Pero eso no es todo."
        </h2>

        <p className="font-serif text-xl md:text-2xl text-gray-300 italic" data-id="element-99">
          Porque un sistema sin soporte es como un auto sin ruedas.
        </p>

        <div className="pt-8 space-y-6 text-lg text-gray-400 font-sans leading-relaxed text-left" data-id="element-100">
          <p data-id="element-101">
            Cuando tomé la decisión de armar este programa, me hice una sola
            pregunta:
          </p>

          <div className="pl-6 border-l-2 border-[#d4a853]/30 space-y-4 py-2" data-id="element-102">
            <p className="font-medium text-gray-200" data-id="element-103">
              ¿Qué necesita alguien para que esto funcione de verdad?
            </p>
            <p data-id="element-104">No qué suena bien en una página de ventas.</p>
            <p data-id="element-105">No qué se ve atractivo en un mockup.</p>
            <p data-id="element-106">
              Qué necesita en el mundo real, el lunes a las 8am, cuando tiene
              que arrancar.
            </p>
          </div>

          <p data-id="element-107">Y la respuesta fue clara:</p>

          <ul className="space-y-4" data-id="element-108">
            <li className="flex items-start" data-id="element-109">
              <span className="text-[#d4a853] mr-3 mt-1" data-id="element-110">→</span>
              <span data-id="element-111">Necesita saber por dónde empezar (sin paralizarse).</span>
            </li>
            <li className="flex items-start" data-id="element-112">
              <span className="text-[#d4a853] mr-3 mt-1" data-id="element-113">→</span>
              <span data-id="element-114">
                Necesita responder sin perder tiempo ni clientes en el camino.
              </span>
            </li>
            <li className="flex items-start" data-id="element-115">
              <span className="text-[#d4a853] mr-3 mt-1" data-id="element-116">→</span>
              <span data-id="element-117">
                Y necesita entregar sin caos mientras el sistema se instala.
              </span>
            </li>
          </ul>

          <p className="pt-4" data-id="element-118">Por eso agregué estos tres bonos.</p>

          <div className="p-6 bg-[#111827]/50 border border-[#b8860b]/20 text-center mt-8" data-id="element-119">
            <p className="font-serif text-xl text-[#f0c674]" data-id="element-120">
              Son gratuitos. Son parte del programa. Y probablemente son lo que
              más vas a usar la primera semana.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}